// Utilitaires pour les URLs d’uploads : même base que l’API (constants.js / REACT_APP_API_URL).
import { BASE_URL } from '../constants';

export const getImageUrl = (imagePath) => {
  if (!imagePath) return '/images/placeholder.jpg';

  if (imagePath.startsWith('http')) return imagePath;

  const base = BASE_URL || '';

  if (imagePath.startsWith('/uploads/')) {
    return `${base}${imagePath}`;
  }

  if (imagePath.startsWith('/images/')) {
    return imagePath;
  }

  const trimmed = String(imagePath).replace(/^\/+/, '');
  return `${base}/uploads/${trimmed}`;
};

export const getUploadUrl = () => `${BASE_URL || ''}/api/upload`;